<template><div class="posA bgContent bdSub device-param-box taL boxR lh13" v-show="showParam" :style="sty" :class="w">
	<div class="device-param-choose body">
		<div class="content w100pct mt1x h20x-max pb1x" scroll>
			<div class="mr1x cb fL_E" :class="{w33pct_E:listData.length>30,w50pct_E:listData.length<=30}">
				<div  v-for="item in listData" :key="item.storageName">
					<span v-if="item.onlySolarman">
						<Checkbox @Click="inputCheck" v-model="item.isBeingSelected" :text="item.name" v-show="stage.loc.customer=='SOLARMAN'" class="pl1x pb05x"></Checkbox>
					</span>
					<span v-else>
						<Checkbox @Click="inputCheck" v-model="item.isBeingSelected" :text="item.name" class="pl1x pb05x"></Checkbox>
					</span>
				</div>
			</div>
		</div>
		<div class="pr1x vaM_E bdSub-top pt05x pb05x taR">
			<button type="button" @click="showDefault">{{getLanguageStr("cmd46",'恢复默认')}}</button>
			<button class="pl1x" type="button" @click="clear">{{getLanguageStr('cmd47','清空选择')}}</button>
			<button class="functionBtn sizeM ml1x" type="button" @click="confirm">{{getLanguageStr("cmd12",'确定')}}</button>
			<!--<button :class="{'disable':disable}" class="functionBtn" type="button" @click="confirm">{{getLanguageStr("cmd84",'保存')}}</button>-->
		</div>
	</div>
</div>
</template>
<script>
import * as lib from '@/util/lib.js'

import InputText from '@/components/common/ui/InputText.vue'
import ChildSysConfig from '@/components/common/ChildSysConfig'
import Checkbox from '@/components/common/ui/Checkbox'
import {getLanguageStr} from '@/util/language'
import {AddChildSys, EditChildSys} from '@/api/maintain/plant/list'

import {deviceParams} from '@/api/device/list'

export default {
  name: 'DeviceDetailParamChooice',
  components: {ChildSysConfig, InputText, Checkbox},
  props: {
    productId: {
      type: [String, Number],
      default: null
    },
    rightSide: {
      type: [String, Number],
      default: null
    },
    sty: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      stage,
      w: 'w20x', // listData.length
      title: '',
      listData: [],
      curParamArray: [],
      defaultParamArray: [],
      disable: false,
      showParam: false,
      defaultSelect: false,
      temp: ''// 用以对比每次传入的productId
    }
  },
  methods: {
    getLanguageStr,
    initShowParam (v) {
      this.showParam = v
    },
    show (curL, dfL, defaultSelect) {
      if (!defaultSelect) {
        //			this.defaultSelect=false
        //				this.curParamArray = curL;
        //	this.defaultParamArray = dfL;
        //				this.getParamList();
        this.defaultSelect = false
      } else {
        this.defaultSelect = true
        this.listData = curL
        this.defaultParamArray = dfL
      }
      this.title = getLanguageStr('word566', '参数选择')
      this.showParam = !this.showParam
      let w = 0
      if (this.listData.length > 30) {
      	this.w = 'w40x'
      	w = 40
      } else {
      	this.w = 'w30x'
      	w = 30
      }
      if (this.rightSide != null) {
      	let baseFontSize = parseInt(window.getComputedStyle(document.body).fontSize)
      	if (baseFontSize * w > this.rightSide) {
      		this.w = this.w + ' rightZero'
      	}
      }
    },
    //		getParamList(){
    //			deviceParams({productId:this.productId,lan:getLanguageType(stage.languageId)}).then(response=>{
    //				this.listData = response.map(item=>{
    //					if(this.curParamArray.includes(item.storageName)) item.selected = true; else item.selected = false;
    //					return item;
    //				})
    //			},error=>{
    //				lib.loadingChange($("#chartLine [Loading]"),false);
    //				this.isChart=false
    //				!_.isEmpty(error) && this.$notify(error)
    //			})
    //		},
    ifInclude (response) {
      let us = false
      response.map((item, index) => {
        if (['The_dyd_P1', 'IRR_dyd_inc_plane1'].includes(item.storageName)) us = true
      })
      return us
    },
    getDefaultParamList (p, t, ty = 1, aindex = 1) {
      var _this = this
      return new Promise(function (resolve, reject) {
        deviceParams({ productId: p, lan: stage.languageId, queryType: ty }).then(response => {
          if (t == 'INVERTER' && (aindex == 1 || aindex == 0)) { // 逆变器
            _this.curParamArray = ['DV1', 'APo_t1', 'T_AC_OP']
          } else if (t == 'INVERTER' && aindex == 2) { // 逆变器 月
            _this.curParamArray = ['generation', 'grid']// Etdy_ge1', 't_gc_tdy1
          } else if (t == 'INVERTER' && aindex == 3) { // 逆变器 年
            _this.curParamArray = ['generation', 'grid']
          } else if (t == 'INVERTER' && aindex == 4) { // 逆变器 总
            _this.curParamArray = ['generation', 'grid']
          } else if (t == 'PV_MODULE') { // 组件
            _this.curParamArray = ['DV1', 'DC1']
          } else if (t == 'METER' && (aindex == 1 || aindex == 0)) { // 电表
            _this.curParamArray = ['Etdy_pos1', 'Pt1']
          } else if (t == 'METER' && aindex == 2) { // 电表 月
            _this.curParamArray = ['electricityForward1']
          } else if (t == 'METER' && aindex == 3) { // 电表 月
            _this.curParamArray = ['electricityForward1']
          } else if (t == 'METER' && aindex == 4) { // 电表 总
            _this.curParamArray = ['electricityForward1']
          } else if (t == 'WEATHER_STATION' && (aindex == 1 || aindex == 0) && _this.ifInclude(response)) {
            _this.curParamArray = ['The_dyd_P1', 'IRR_dyd_inc_plane1']
          } else if (t == 'BATTERY' && (aindex == 1 || aindex == 0)) {
            _this.curParamArray = ['SOC_BAP1', 'SOH_BAP1']
          } else if (t == 'WATER_PUMP' && (aindex == 1 || aindex == 0)) {
            _this.curParamArray = ['S_count1', 'DP1']
          } else { // 非此三类型，默认选择第一或第二选项
            if (response.length == 1) {
              _this.curParamArray.push(response[0].storageName)
            } else if (response.length > 1) {
              _this.curParamArray.push(response[0].storageName, response[1].storageName)
            } else {
              _this.curParamArray = []
            }
          }
          // if (p.split('_')[1] === '270A') {
          //   _this.curParamArray.push('T_AC_OP')
          // }
          if (response) {
            _this.listData = response.map((item, index) => {
              if (_this.curParamArray.includes(item.storageName)) item.isBeingSelected = true
              return item
            })
            _this.$emit('GetParam', _this.listData)
				    }
				    _this.defaultParamArray = _this.curParamArray
				    resolve(_this.curParamArray)
        }, error => {
          lib.loadingChange($('#chartLine [Loading]'), false)
          this.isChart = false
          !_.isEmpty(error) && this.$notify(error)
          reject()
        })
	    })
    },
    clear () {
      this.listData = _.cloneDeep(this.listData.map(item => { item.isBeingSelected = false; return item }))
      this.inputCheck()
    },
    inputCheck: function () {
      let l = this.listData.filter(item => item.isBeingSelected == true)
      this.$emit('beingParamArray', this.listData)// 鼠标离开后保留选中状态20190708
      this.disable = (l.length == 0)
    },
    showDefault () {
      if (this.defaultSelect) {
        this.listData = _.cloneDeep(this.defaultParamArray)
      } else {
        if (this.defaultParamArray.length > 0) {
          this.listData = this.listData.map(item => {
            if (this.defaultParamArray.includes(item.storageName))item.isBeingSelected = true; else item.isBeingSelected = false
            return item
          })
          this.listData = _.cloneDeep(this.listData)
        }
      }
      this.inputCheck()
    },
    hide () {
      this.showParam = false
    },
    confirm () {
    	this.listData.forEach(function (i) {
		  i.selected = i.isBeingSelected
      })
      let sList = this.listData.filter(item => item.selected)
      if (sList.length > 8) {
        this.$notify(i18n.t('fill3rd2', [8]))
        return false
      } else {
        if (this.defaultSelect) {
          this.$emit('selectArray', this.listData)
        } else {
          let selectArray = sList.map(item => { return item.storageName })
          this.$emit('selectArray', selectArray)
        }

        this.showParam = false
      }
    }
  },
  mounted () {
    lib.setScroll($('.device-param-choose .content[scroll]'))
  }
}
</script>
<style scoped lang="scss">
.device-param-box{z-index:1;
	border-radius: 0.3em;
	cursor: default !important;
	@extend %boxShadowPublic;
}
.rightZero{
	right:0
}
</style>



// WEBPACK FOOTER //
// src/view/device/device/part/DeviceDetailParam.vue